export const PLATEFORME = {
  AFFELNET: "affelnet",
  PARCOURSUP: "parcoursup",
};
